import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.SetCurrentTaskSupplierApproval.title',
    defaultMessage: 'Approve on behalf of voice talent',
  },
  cancel: {
    id: 'containers.OrderPage.components.TaskPage.components.SetCurrentTaskSupplierApproval.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.SetCurrentTaskSupplierApproval.loading',
    defaultMessage: 'Approving..',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.SetCurrentTaskSupplierApproval.submit',
    defaultMessage: 'Approve',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskPage.components.SetCurrentTaskSupplierApproval.sideEffects',
    defaultMessage: `
      <li>Task will be assigned to selected voice talent</li>
      <li>Voice talent will be notified on e-mail</li>
      <li>Recordings can now be uploaded by voicet talent</li>
    `
  },
})
